<!-- <p>home-page works!</p> -->
<app-header></app-header>
<app-strength-container></app-strength-container>
<app-experience></app-experience>
<!-- <app-footer></app-footer> -->
